import request from '@/utils/request'
import type { AxiosResponse } from 'axios'
import type { MailPreferences } from '@/models/MailFolder'

/** GET /api/v2/mail-preferences — the caller's viewer settings (empty defaults). */
export function getMailPreferences(): Promise<AxiosResponse<{ data: MailPreferences }>> {
  return request({ url: '/api/v2/mail-preferences', method: 'get' })
}

/** PUT /api/v2/mail-preferences — replaces the settings; answers with the stored (pruned) state. */
export function updateMailPreferences(data: MailPreferences): Promise<AxiosResponse<{ data: MailPreferences }>> {
  return request({ url: '/api/v2/mail-preferences', method: 'put', data })
}
